<template>
  <div class="page page-padding" style="background: #F1F1F1;">
    <div class="form-item-group">
      <div class="form-item">
        <div class="form-item__label">服务类型</div>
        <div class="form-item__value">代驾车检</div>
      </div>
    </div>

    <div class="form-item-group">
      <div class="form-item">
        <div class="form-item__label">所在地区</div>
        <div class="form-item__value" @click="() => {this.areaPopupShow = true}">{{location?location:'请选择省市区'}}</div>
      </div>
      <div class="form-item">
        <div class="form-item__label">详细地址</div>
        <div class="form-item__value">
          <input v-model="address" placeholder="请输入详细地址">
        </div>
      </div>
      <div class="form-item">
        <div class="form-item__label">接车费用</div>
        <div class="form-item__value price">
          <span style="font-size: 10px">￥</span>{{pickCarPrice}}
        </div>
      </div>
      <div class="form-item">
        <div class="form-item__label">检测费用</div>
        <div class="form-item__value price">
          <span style="font-size: 10px">￥</span>{{inspectPrice}}
        </div>
      </div>
    </div>
    <div class="form-item-group">
      <div class="form-item">
        <div class="form-item__label">接车日期</div>
        <div class="form-item__value" @click="()=>{this.calendarShow=true}">{{ pockCarDateFormat}}</div>

      </div>
      <div class="form-item">
        <div class="form-item__label">接车时间</div>
        <div class="form-item__value" @click="()=>{this.pickCarTimeShow=true}">{{ pickCarTimeFormat}}</div>
      </div>
    </div>

    <van-button round class="book-next-btn" :disabled="nextBtnDisabled" @click="settlement">下一步</van-button>
    <van-popup v-model="pickCarTimeShow" position="bottom">
      <van-datetime-picker
              v-model="pickCarTime"
              type="time"
              title="选择时间"
              :min-hour="9"
              :max-hour="16"
              :filter="pickCarTimeFilter"
              @confirm="(value)=>{this.pickCarTime = value;this.pickCarTimeShow=false;}"
              @cancel="()=>{this.pickCarTimeShow=false}"
      />
    </van-popup>

    <van-popup v-model="areaPopupShow" position="bottom">
      <van-area :area-list="areaList" @confirm="areaConfirm" @cancel="() => {this.areaPopupShow = false}"/>
    </van-popup>
    <van-calendar v-model="calendarShow" :min-date="minDate" color="#7EB375" @confirm="calendarConfirm"/>
  </div>
</template>

<script>
  import {Calendar, Button, DatetimePicker, Popup, Area, Notify} from 'vant';
  import dateUtil from "../../utils/dateUtil";
  import areaList from '../../config/areaList';

  export default {
    name: "bookOrder",
    components: {
      vanCalendar: Calendar,
      vanButton: Button,
      vanDatetimePicker: DatetimePicker,
      vanPopup: Popup,
      vanArea:Area
    },
    data() {
      return {
        areaList,
        location: null,
        address: '',
        calendarShow: false,
        pickCarTimeShow: false,
        areaPopupShow: false,
        pickCarDate: null,
        pickCarTime: null,
        pickCarPrice:0,
        inspectPrice:0,
        nextBtnDisabled:true,
        minDate:null,
      }
    },
    computed: {
      pockCarDateFormat() {
        if (this.pickCarDate == null) {
          return "请选择接车日期";
        }
        return dateUtil.format(this.pickCarDate, "yyyy-MM-dd")
      },
      pickCarTimeFormat() {
        if (this.pickCarTime == null) {
          return "请选择接车时间";
        }
        return this.pickCarTime;
      },
    },
    methods: {
      settlement(){
        if(this.location == null){
          Notify("请选择省市区")
          return;
        }
        if(this.address == ""){
          Notify("请填写详细地址")
          return;
        }
        if(this.pickCarTime == null){
          Notify("请选择接车时间")
          return;
        }
        if(this.pickCarDate == null){
          Notify("请选择接车日期")
          return;
        }
        // eslint-disable-next-line no-debugger
        debugger
        this.$store.commit("SET_ORDER",{
          location:this.location,
          address:this.address,
          planTime:this.pickCarTime,
          planDate:dateUtil.format(this.pickCarDate,'yyyy-MM-dd'),
          configId:this.configId,
          orderType:18,
        });
        this.$router.push("/settlement");
      },
      areaConfirm(areaArr) {
        this.location = areaArr.map(item => item.name).join("");
        this.areaPopupShow = false;
        this.getPickCarConfig(areaArr[0].name, areaArr[1].name);
      },
      pickCarTimeFilter(type, options) {
        if (type === 'minute') {
          return options.filter((option) => option % 15 === 0);
        }
        return options;
      },
      calendarConfirm(date) {
        this.pickCarDate = date;
        this.calendarShow = false;
      },
      getPickCarConfig(province, city){
        this.$http.get(`/pickcar/config?province=${province}&city=${city}`)
        .then(resp => {
          if(resp.success){
            if(resp.data != null){
              this.pickCarPrice = resp.data.pickCarPrice;
              this.inspectPrice = resp.data.inspectPrice;
              this.configId = resp.data.configId;
              this.nextBtnDisabled = false;
            } else {
              Notify("当前地址不支持接车年检") ;
              this.nextBtnDisabled = true;
              this.pickCarPrice = 0;
              this.inspectPrice = 0;
            }
          }
        })
      }
    },
    created() {
      const now  = new Date();
      const minDate = new Date(now);
      minDate.setDate(now.getDate() + 1);
      this.minDate = minDate;
    }
  }
</script>

<style lang="less" scoped>
  .form-item-group {
    background: #FFF;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    padding: 0 22.5px;
    width: 345px;
    margin: 0 auto 10px;
    box-sizing: border-box;
  }

  .form-item {
    display: flex;
    align-items: center;
    height: 54px;

    border-bottom: 1px solid #ebedf0;
    box-sizing: border-box;

    &__label {
      color: #393939;
      font-weight: 500;
      font-size: 18px;
    }

    &__value {
      margin-left: 25px;
      flex: 1;
      display: flex;
      align-items: center;
      font-size: 15px;
      &.price{
        color:#E54A4A;
        font-size: 18px;
      }
      input {
        border: none;
        line-height: 54px;
        height: 50px;
        width: 100%;
      }
    }
  }

  .book-next-btn {
    background: #7EB375;
    color: #FFF;
    font-weight: bold;
  }
</style>
